export default "__VITE_ASSET__DptLXSQY__"